import {
  NavigationBlockState,
  NavigationBlockType,
} from "../types/NavigationBlocks";

// Фабричные функции для создания блоков навигации

export const createOrganisationBlock = (
  organisationId: string,
  organisationName: string,
  currentSector: string,
  additionalData?: any
): NavigationBlockState => ({
  type: NavigationBlockType.ORGANISATION_SIDEBAR,
  title: organisationName,
  data: {
    organisationId,
    organisationName,
    currentSector,
    activeSidebarTab: "StateOrganisations",
    ...additionalData,
  },
});

export const createInitiativeBlock = (
  initiativeId: string,
  initiativeName: string,
  organisationData: any,
  additionalData?: any
): NavigationBlockState => ({
  type: NavigationBlockType.INITIATIVE_WITH_WORKERS,
  title: initiativeName,
  data: {
    initiativeId,
    initiativeName,
    // Сохраняем данные родительской организации
    organisationId: organisationData.organisationId,
    organisationName: organisationData.organisationName,
    currentSector: organisationData.currentSector,
    activeSidebarTab: "StateInitiative",
    isOpenOrganisationsRadar: true, // Включаем радар для просмотра сотрудников
    ...additionalData,
  },
});

export const createWorkerBlock = (
  workerId: string,
  workerName: string,
  workerPosition: string,
  initiativeData: any,
  additionalData?: any
): NavigationBlockState => ({
  type: NavigationBlockType.WORKER_WITH_CONNECTIONS,
  title: `${workerName} - ${workerPosition}`,
  data: {
    workerId,
    workerName,
    workerPosition,
    // Сохраняем данные родительской инициативы
    initiativeId: initiativeData.initiativeId,
    initiativeName: initiativeData.initiativeName,
    organisationId: initiativeData.organisationId,
    organisationName: initiativeData.organisationName,
    activeSidebarTab: "StateWorker",
    isOpenWorkerRadar: true, // Включаем радар связей сотрудника
    ...additionalData,
  },
});

// Вспомогательные функции для определения типа текущего состояния
export const shouldShowOrganisationSidebar = (
  block: NavigationBlockState | null
): boolean => {
  return block?.type === NavigationBlockType.ORGANISATION_SIDEBAR;
};

export const shouldShowInitiativeView = (
  block: NavigationBlockState | null
): boolean => {
  return block?.type === NavigationBlockType.INITIATIVE_WITH_WORKERS;
};

export const shouldShowWorkerView = (
  block: NavigationBlockState | null
): boolean => {
  return block?.type === NavigationBlockType.WORKER_WITH_CONNECTIONS;
};

// Функция для получения заголовка на основе блока
export const getBlockTitle = (block: NavigationBlockState | null): string => {
  if (!block) return "";

  switch (block.type) {
    case NavigationBlockType.ORGANISATION_SIDEBAR:
      return block.data?.organisationName || block.title;
    case NavigationBlockType.INITIATIVE_WITH_WORKERS:
      return block.data?.initiativeName || block.title;
    case NavigationBlockType.WORKER_WITH_CONNECTIONS:
      return (
        `${block.data?.workerName} - ${block.data?.workerPosition}` ||
        block.title
      );
    default:
      return block.title;
  }
};
